import React, { useEffect, useState } from "react";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  TITLE,
  ENGLISH,
  HINDI,
  HOME,
  PARTNER,
  ABOUT,
  CONTACT,
  NAV_NEWS,
  NAV_CTA,
} from "../data/navbar/menu";
import {
  OUR_BRANDS_LABEL,
  BRAND_NUKRISHI_NAME,
  BRAND_AMERICANBULLS_NAME,
} from "../data/i18n/brands";
import { NUKRISHI_URL, AMERICANBULLS_URL } from "../data/brandUrls";
import Container from "react-bootstrap/Container";
import "../styles/AppBar.css";

import Logo from "../assets/images/new_fk_logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLanguage } from "@fortawesome/free-solid-svg-icons";

let menuBeforeBrands = [
  {
    title: HOME,
    link: "/#home",
  },
  {
    title: ABOUT,
    link: "/about",
  },
];

let menuAfterBrands = [
  {
    title: NAV_NEWS,
    link: "/#news",
  },
  {
    title: PARTNER,
    link: "/#partner",
  },
  {
    title: CONTACT,
    link: "/#contact",
  },
];

const AppBar = ({ alwaysSolid }) => {
  const { t, i18n } = useTranslation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    if (alwaysSolid) return;
    const handleScroll = () => setScrolled(window.scrollY > 60);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [alwaysSolid]);

  const handleLangChange = (newlang) => {
    i18n.changeLanguage(newlang);
  };
  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      variant="dark"
      fixed="top"
      className={scrolled || alwaysSolid ? "solid" : ""}
    >
      <Container>
        <Navbar.Brand href="/#home">
          <img
            alt={t(TITLE)}
            src={Logo}
            height="38"
            className="d-inline-block align-top brand-logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Nav>
            {menuBeforeBrands.map((menuItem) => (
              <Nav.Link key={menuItem.link} href={menuItem.link}>
                {t(menuItem.title)}
              </Nav.Link>
            ))}
            <NavDropdown title={t(OUR_BRANDS_LABEL)} id="brands-nav-dropdown">
              <NavDropdown.Item
                href={NUKRISHI_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t(BRAND_NUKRISHI_NAME)}
              </NavDropdown.Item>
              <NavDropdown.Item
                href={AMERICANBULLS_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t(BRAND_AMERICANBULLS_NAME)}
              </NavDropdown.Item>
            </NavDropdown>
            {menuAfterBrands.map((menuItem) => (
              <Nav.Link key={menuItem.link} href={menuItem.link}>
                {t(menuItem.title)}
              </Nav.Link>
            ))}
            <Nav.Link href="/#contact" className="btn-nav-cta">
              {t(NAV_CTA)}
            </Nav.Link>
            <NavDropdown
              title={<FontAwesomeIcon icon={faLanguage} size="lg" />}
              id="basic-nav-dropdown"
            >
              <NavDropdown.Item onClick={() => handleLangChange("hin")}>
                {t(HINDI)}
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleLangChange("en")}>
                {t(ENGLISH)}
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default AppBar;
